export enum ORG_TYPE {
  COMPANY = 'COMPANY',
  STUDENT_ORG = 'STUDENT_ORG',
}
